import { PERMISSIONS } from "../../../../auth/permissions";
import Badge from "../../Badge";
import { ContentBase } from "../ContentBase";
import { GenerateElementProps, IContent } from "../IContent";

export class BadgeContent extends ContentBase {
  private title?: string;
  private customContent?: IContent;

  constructor(
    private content: string,
    styles = "",
    permissions: PERMISSIONS[] = [],
    condition = () => true,
    testAttribute?: string,
  ) {
    super(styles, permissions, condition, testAttribute);
  }

  protected generateContentElement(props: GenerateElementProps): JSX.Element {
    return (
      <Badge
        content={this.content}
        classname={this.styles}
        title={this.title}
        data-cy={this.testAttribute}
      >
        {this.customContent?.generateElement(props)}
      </Badge>
    );
  }

  withTitle(title: string): BadgeContent {
    const c = this.clone();
    c.title = title;
    return c;
  }

  withCustomContent(customContent: IContent): BadgeContent {
    const c = this.clone();
    c.customContent = customContent;
    return c;
  }

  clone(): BadgeContent {
    const item = new BadgeContent(
      this.content,
      this.styles,
      this.permissions,
      this.condition,
    );
    item.title = this.title;
    item.customContent = this.customContent;
    return item;
  }
}
